/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type OptimizeWorkTypeSchemePageType from '@jira/site-optimizer__optimize-work-type-scheme-page/src/OptimizeWorkTypeSchemePage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyOptimizeWorkTypeSchemePagePage: LazyComponent<
	typeof OptimizeWorkTypeSchemePageType
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof OptimizeWorkTypeSchemePageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-jira-admin-pages-optimize-work-type-scheme-page", jiraSpaEntry: "async-jira-admin-pages-optimize-work-type-scheme-page" */ '@jira/site-optimizer__optimize-work-type-scheme-page/src/OptimizeWorkTypeSchemePage.tsx'
				),
			),
		{ ssr: false },
	);

export const OptimizeWorkTypeSchemePage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOptimizeWorkTypeSchemePagePage}
		pageId="jira-admin-pages-optimize-work-type-scheme-page"
		shouldShowSpinner
	/>
);
